/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrencyRateDto
 */
export interface CurrencyRateDto {
    /**
     * 
     * @type {string}
     * @memberof CurrencyRateDto
     */
    symbol: string;
    /**
     * 
     * @type {number}
     * @memberof CurrencyRateDto
     */
    rate: number;
    /**
     * 
     * @type {Date}
     * @memberof CurrencyRateDto
     */
    date: Date;
}

export function CurrencyRateDtoFromJSON(json: any): CurrencyRateDto {
    return CurrencyRateDtoFromJSONTyped(json, false);
}

export function CurrencyRateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyRateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbol': json['symbol'],
        'rate': json['rate'],
        'date': (new Date(json['date'])),
    };
}

export function CurrencyRateDtoToJSON(value?: CurrencyRateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbol': value.symbol,
        'rate': value.rate,
        'date': (value.date.toISOString()),
    };
}

